// src/pages/purchase-requisition/hooks/useOrderSearch.jsx
import { useState, useMemo } from "react";

/**
 * Custom hook for managing search functionality and filtering orders.
 * @param {Array} orders - The original list of orders to be filtered.
 * @returns {object} An object containing the search term, its setter, and the filtered orders.
 */
const useOrderSearch = (orders) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredOrders = useMemo(() => {
        if (!searchTerm) {
            return orders;
        }
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return orders.filter(order => {
            // Search by Order ID
            if (order.id && order.id.toLowerCase().includes(lowerCaseSearchTerm)) {
                return true;
            }
            
            // Search by Order Title (Judul Order)
            if (order.order_title && order.order_title.toLowerCase().includes(lowerCaseSearchTerm)) {
                return true;
            }

            // TAMBAHKAN: Search by No PR
            if (order.no_pr && order.no_pr.toLowerCase().includes(lowerCaseSearchTerm)) {
                return true;
            }
            
            // Search by status
            if (order.status && order.status.toLowerCase().includes(lowerCaseSearchTerm)) {
                return true;
            }
            
            // Search by creator name
            if (order.created_by_name && order.created_by_name.toLowerCase().includes(lowerCaseSearchTerm)) {
                return true;
            }
            
            // Search by item details
            if (order.item_details && Array.isArray(order.item_details)) {
                return order.item_details.some(item =>
                    (item.material_code && item.material_code.toLowerCase().includes(lowerCaseSearchTerm)) ||
                    (item.material_description && item.material_description.toLowerCase().includes(lowerCaseSearchTerm)) ||
                    (item.cost_center && item.cost_center.toLowerCase().includes(lowerCaseSearchTerm)) ||
                    (item.notes && item.notes.toLowerCase().includes(lowerCaseSearchTerm))
                );
            }
            return false;
        });
    }, [orders, searchTerm]);

    return {
        searchTerm,
        setSearchTerm,
        filteredOrders,
    };
};

export default useOrderSearch;